import React, { useState } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
  Skeleton,
} from "@mui/material";

const AddProduct = () => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true);
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setLoading(false);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined">Save to draft</Button>
          <Button variant="contained" color="success">
            Publish
          </Button>
        </Box>
      </Grid>

      <Typography variant="h5" fontWeight="bold" mb={2}>
        Add New Product
      </Typography>

      <Grid container spacing={2}>
        {/* Basic Section */}
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Basic
              </Typography>

              <Typography variant="subtitle1">Product Title</Typography>
              <TextField
                fullWidth
                label="Enter product title"
                margin="normal"
              />

              <Typography variant="subtitle1">Full Description</Typography>
              <TextField
                fullWidth
                label="Enter full description"
                margin="normal"
                multiline
                rows={4}
              />

              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Typography variant="subtitle1">Regular Price</Typography>
                  <TextField fullWidth label="$" type="number" />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle1">Promotional Price</Typography>
                  <TextField fullWidth label="$" type="number" />
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle1">Currency</Typography>
                  <FormControl fullWidth>
                    <InputLabel>USD</InputLabel>
                    <Select>
                      <MenuItem value="USD">USD</MenuItem>
                      <MenuItem value="INR">INR</MenuItem>
                      <MenuItem value="EUR">EUR</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Typography variant="subtitle1">Tax Rate</Typography>
              <TextField fullWidth label="%" margin="normal" />

              <Box display="flex" alignItems="center">
                <Checkbox />
                <Typography>Make a template</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>


        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card sx={{ flexGrow: 1, height: 100 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Media
              </Typography>
              <Box
                sx={{
                  border: "1px dashed gray",
                  padding: 2,
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {loading ? (
                  <Skeleton variant="rectangular" width={120} height={120} />
                ) : image ? (
                  <img
                    src={image}
                    alt="Uploaded"
                    width={120}
                    height={120}
                    style={{ borderRadius: 5 }}
                  />
                ) : (
                  <Skeleton variant="rectangular" width={120} height={120} />
                )}
                <Button variant="contained" component="label" sx={{ mt: 2 }}>
                  Choose File
                  <input type="file" hidden onChange={handleImageUpload} />
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Shipping
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">Width </Typography>
                  <TextField fullWidth label="Inch" />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">Height </Typography>
                  <TextField fullWidth label="Inch" />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">Weight </Typography>
                  <TextField fullWidth label="Gam" />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">Shipping Fees </Typography>
                  <TextField fullWidth label="$" />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Organization Section */}
        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card sx={{ flexGrow: 1 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Organization
              </Typography>

              <Typography variant="subtitle1">Category</Typography>
              <FormControl fullWidth margin="normal">
                <InputLabel>Select Category</InputLabel>
                <Select>
                  <MenuItem value="Automobiles">Automobiles</MenuItem>
                </Select>
              </FormControl>

              <Typography variant="subtitle1">Sub-category</Typography>
              <FormControl fullWidth margin="normal">
                <InputLabel>Select Sub-category</InputLabel>
                <Select>
                  <MenuItem value="Nissan">Nissan</MenuItem>
                </Select>
              </FormControl>

              <Typography variant="subtitle1">Tags</Typography>
              <TextField fullWidth label="Enter tags" margin="normal" />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddProduct;
